import { ChartMark, WidgetKind, type Report } from 'corso-admin-ui';
import { online } from './filters';

export const orders = {
  key: 'orders',
  label: 'Orders',
  dataset: 'orders',
  timeFields: ['orderedOn'],
  widgets: [
    {
      kind: WidgetKind.kpi,
      title: 'Online orders',
      metric: 'orders',
      filters: online,
    },
    { kind: WidgetKind.kpi, metric: 'protectedOrders' },
    {
      kind: WidgetKind.kpi,
      title: 'Attach rate (web channels)',
      description: 'Online orders that are protected',
      metric: 'attachRate',
      filters: online,
    },
    {
      kind: WidgetKind.kpi,
      title: 'Attach rate (all channels)',
      description: 'All orders that are protected',
      metric: 'attachRate',
    },
    {
      kind: WidgetKind.kpi,
      description: "At the current price of each order's protection tier",
      metric: 'avgProtectionPrice',
    },
    {
      kind: WidgetKind.overTime,
      title: 'Protected orders over time',
      mark: ChartMark.line,
      metrics: ['protectedOrders'],
    },
    {
      kind: WidgetKind.overTime,
      title: 'Attach rate over time (web channels)',
      description: 'Online orders that are protected',
      mark: ChartMark.line,
      metrics: ['attachRate'],
      filters: online,
    },
    {
      kind: WidgetKind.table,
      title: 'Orders by sales channel',
      description: 'Shopify names third-party channels by number',
      dimensions: ['salesChannel'],
      metrics: ['orders', 'protectedOrders'],
    },
  ],
} as const satisfies Report;
